
<template>

    <div class="col-sm-12 bg-lightest border-light cardHeight2 d-flex flex-column radius-normal">
        <div class="mb-3">
            <div class="text-center darker font-weight-600 mt-4 fs-large">
                {{title}}
            </div>

        </div>
        <div class="text-center w-100 mb-5 mt-1">
            <ul class="text-left">
                <li v-for="reportItem in reportList" v-if="reportItem.active">
                    <router-link class="darker" :to="{ name: reportItem.link, params: {} }">{{reportItem.label}}</router-link>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    export default {
        data: function(){
            return {
                reportList:[
                    {
                        label:'Daily report',
                        active: false,
                        link: '',
                    },
                    {
                        label:'Bookings report',
                        active: false,
                        link: '',
                    },
                    {
                        label:'Sales report',
                        active: false,
                        link: 'pluralo.reports.sales',
                    },
                    {
                        label:'Agent sales report',
                        active: true,
                        link: 'pluralo.reports.new',
                    },
                    {
                        label:'Team sales report',
                        active: false,
                        link: '',
                    },
                    {
                        label:'Occupancy report',
                        active: false,
                        link: '',
                    }
                ]
            }
        },
        props:[
            'title',
        ]
    }
</script>

<style scoped lang="scss">

    .cardHeight1{
        height: 230px;
    }

    .fs-superBig{
        font-size: 2.5rem;
    }
</style>



// WEBPACK FOOTER //
// cardReportList.vue?6b12e855